/** Configuration API — injectée par l'environnement, jamais de secret en clair. */

const configuredBaseUrl: string | undefined = import.meta.env.VITE_API_BASE_URL;

/** Origine de l'API ONIRIA (vide = même origine que la SPA). */
export const API_BASE_URL: string = (configuredBaseUrl ?? '').replace(/\/+$/, '');

/** Clés d'endpoints versionnées (contrats backend vérifiés dans ONIRIA). */
export const API_ENDPOINTS = {
  auth: {
    login: '/api/v2/auth/login',
    refresh: '/api/v2/auth/refresh',
    setPassword: '/api/v2/auth/set-password',
  },
  profile: {
    update: '/api/v2/profile',
  },
  chatbots: {
    listOwn:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.chatbots.list-own',
    setPause: '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.set-pause',
    requestResiliation:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.request-resiliation',
  },
  chatbotRequests: {
    create:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.create-chatbot-request',
    listOwn:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.bot-requests.list-own',
  },
  supportRequests: {
    create:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.create-support-request',
    listOwn:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.support-requests.list-own',
    getOwn:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.support-requests.get-own',
  },
  conversations: {
    listOwn:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.conversations.list-own',
    getOwn:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.conversations.get-own',
    create:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.conversations.create',
    messagesCreate:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.conversations.messages.create',
    attachmentsUpload:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.conversations.attachments.upload',
    attachmentsDownload:
      '/api/v3/packages/madatalk-requests/endpoints/madatalk-requests.client.conversations.attachments.download',
  },
} as const;

export type AuthEndpointKey = keyof typeof API_ENDPOINTS.auth;
